module.exports = __webpack_public_path__ + "7aecb11535b343c812a0bad1be7b2867.svg";